<!--
    描述： 上传组件
    时间： 2020-03-23
    created by ws
-->
<template>
	<div class="upload-layout">
		<el-upload class="upload-demo"
				   ref="upload"
				   action=""
				   :disabled="isDisabled"
				   :limit="maxNum"
				   :on-exceed="onExceed"
				   :on-change="onChange"
				   :file-list="fileList"
				   :multiple="multiple"
				   :auto-upload="false">
			<el-button slot="trigger"
					   size="small"
					   v-if="mode !== 'view'"
					   type="primary">选取文件</el-button>
			<!-- 自定义文件列表 -->
			<div slot="file"
				 class="file-item"
				 slot-scope="{file}">
				<div class="item-left text-overflow">
					<em class="el-icon-document"></em>
					<a href="javascript:;">{{ file.id ? file.fileName : file.name }}</a>
				</div>
				<div class="item-right">
					<em class="mr5 el-icon-zoom-in"
						title="查看"
						@click="doView(file)"></em>
					<!-- <em class="mr5 el-icon-download"
						title="下载"
						@click="doDownload(file)"></em> -->
					<em class="mr5 el-icon-delete"
						title="删除"
						v-if="mode !== 'view'"
						@click="doDelete(file)"></em>
				</div>
			</div>
			<div slot="tip"
				 v-if="mode !== 'view'"
				 class="el-upload__tip file-tip">
				<p>当前支持文件格式为: {{ acceptMsg }}</p>
			</div>
			<!-- 没有文件时的文字说明 -->
			<div v-if="fileLength === 0">暂无附件</div>
		</el-upload>
	</div>
</template>

<script>
// import { uploadData, fileEcho, fileView, fileDownload } from 'api/module/upload'
export default {
	name: 'upload_component',
	props: {
		// 当前查看模式
		mode: {
			type: String,
			default: 'add'
		},
		// 最大文件上传个数
		maxNum: {
			type: Number,
			default: 10
		},
		// 是否支持多选
		multiple: {
			type: Boolean,
			default: true
		},
		// 接收的文件类型
		acceptType: {
			type: Array,
			default: () => {
				return []
			}
		},
		// 回显业务表id
		aid: {
			type: String,
			default: ''
		},
		// 业务表名称
		tableName: {
			type: String,
			default: 'bus_pro_contract'
		}
	},
	data() {
		return {
			fileList: [],
			addList: [],
			delList: [],
			isDisabled: false, // 是否禁用
			isLoaded: false
		}
	},
	methods: {
		// 文件上传方法
		fileUpload(uploadId) {
			// 在有上传数据的情况下
			let _aid = uploadId ? uploadId : this.aid
			if (this.addList.length > 0 || this.delList.length > 0) {
				let delData = JSON.parse(JSON.stringify(this.delList))
				let formData = new FormData()
				for (let item of this.addList) {
					formData.append('file', item)
					// let fileInfo = {}
					// fileInfo.tableName = 'bus_pro_contract'
					// fileInfo.aid = this.aid
					// formData.append(
					// 	item.name + item.raw.size,
					// 	JSON.stringify(fileInfo)
					// )
				}
				formData.append('delfile', delData.join(','))
				formData.append('aid', _aid)
				formData.append('tableName', this.tableName)
				// 执行上传操作
				uploadData(formData).then(res => {
					// console.log(res)
					if (res.operationCode === 1) {
						this.$emit('on-upload', true)
					}
				})
			}
		},
		// 数据回显
		getFiles() {
			fileEcho({ aid: this.aid }).then(res => {
				if (res.code === '0') {
					this.fileList = res.data
				}
			})
		},
		// 文件列表变化事件
		onChange(file, fileList) {
			// console.log(file)
			let curType = file.name.substring(file.name.lastIndexOf('.') + 1)
			if (this.checkType(curType)) {
				// 如果不存在id 是添加情况
				if (!file.id) {
					this.addList.push(file.raw)
				}
			} else {
				this.doDelete(file)
			}
		},
		// 检测所选文件是否符合格式
		checkType(curType) {
			if (this.acceptType.length > 0) {
				if (this.acceptType.find(x => x === curType)) {
					return true
				} else {
					this.$message.error('文件格式不对，请重新选择!')
					return false
				}
			} else {
				return true
			}
		},
		// 文件超出最大个数事件
		onExceed() {
			this.$message.warning('当前最多可上传' + this.maxNum + '个文件！')
		},
		// 查看文件
		doView(file) {
			fileView(file.id)
		},
		// 下载文件
		doDownload(file) {
			fileDownload(file.id)
		},
		// 删除文件
		doDelete(file) {
			let _index = this.$refs.upload.uploadFiles.findIndex(
				x => x.uid === file.uid
			)
			// 如果有ID 弹窗提示
			if (file.id) {
				this.$confirm('确认要删除当前附件吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.delList.push(file.id)
						this.$refs.upload.uploadFiles.splice(_index, 1)
						this.$message.info('移除成功，保存后生效!')
					})
					.catch(() => {})
			} else {
				// 否则直接删除
				this.addList.splice(this.addList.findIndex(x => x.uid === file.uid), 1)
				this.$refs.upload.uploadFiles.splice(_index, 1)
			}
		},
		// 清除文件列表
		clearFiles() {
			this.$refs.upload.clearFiles()
			this.addList = []
			this.delList = []
		}
	},
	created() {
		// 判断是否有数据表ID
		this.aid !== '' ? this.getFiles() : ''
	},
	mounted() {
		// 组件加载完毕后 渲染状态
		this.isLoaded = true
	},
	computed: {
		// 当前文件列表数量
		fileLength() {
			if (!this.isLoaded) {
				return 0
			}
			return this.$refs.upload.uploadFiles.length
		},
		// 支持的文件格式 文字
		acceptMsg() {
			return this.acceptType.length > 0
				? JSON.stringify(this.acceptType)
				: '所有格式文件'
		}
	}
}
</script>

<style lang="less">
.upload-layout {
	text-align: left;
	.file-item {
		display: flex;
		justify-content: space-between;
		padding: 0 5px;
		.item-left {
			width: 80%;
			padding: 0 5px;
			box-sizing: border-box;
		}
		.item-right {
			width: 20%;
			text-align: right;
			em {
				cursor: pointer;
			}
		}
	}
	.file-tip {
		margin-top: 0;
		height: 35px;
		line-height: 35px;
	}
	.el-upload {
		display: unset;
		text-align: left;
	}
}
</style>